var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaintRollerOutline = function SvgPaintRollerOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3c0-1.654-1.346-3-3-3H3C1.346 0 0 1.346 0 3v2c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3 1.103 0 2 .897 2 2v1c0 1.103-.897 2-2 2h-7c-2.206 0-4 1.794-4 4v.184A3 3 0 0 0 7 17v4c0 1.654 1.346 3 3 3s3-1.346 3-3v-4a3 3 0 0 0-2-2.816V14c0-1.103.897-2 2-2h7c2.206 0 4-1.794 4-4V7c0-2.206-1.794-4-4-4m-2 2c0 .552-.449 1-1 1H3c-.551 0-1-.448-1-1V3c0-.552.449-1 1-1h14c.551 0 1 .448 1 1zm-7 16a1.001 1.001 0 0 1-2 0v-4a1.001 1.001 0 0 1 2 0z"
  })));
};
export default SvgPaintRollerOutline;